<div class="page-container">
  <div class="form-container" *ngIf="formGroup">
    <frg-form-input
      id="title"
      type="text"
      label="Titre"
      [required]="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('title')"
    ></frg-form-input>

    <div class="date-wrapper wrapper">
      <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }" *ngIf="formGroup">
        <div class="picker-label">Date *</div>
        <div class="date-picker">
          <mat-form-field appearance="fill">
            <input #date matInput [matDatepicker]="dateStartPicker" placeholder="JJ/MM/YYYY" [formControl]="formGroup.get('dateStart')" rInputMask="99/99/9999">
            <mat-datepicker-toggle matSuffix [for]="dateStartPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateStartPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="date-wrapper wrapper">
        <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }">
          <div class="picker-label">Heure de début *</div>
          <ngx-timepicker-field (timeChanged)="timeChanged($event, 'hourStart')"
            [defaultTime]="formGroup.get('hourStart').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
            [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon"
            [min]="dayStartHour" [max]="dayEndHour">
          </ngx-timepicker-field>
        </div>
      </div>
      <div class="date-wrapper wrapper">
        <div class="picker-wrapper" [ngClass]="{ 'highlight': isDateTimeHighlighted }">
          <div class="picker-label">Heure de fin *</div>
          <ngx-timepicker-field #timeEnd (timeChanged)="timeChanged($event, 'hourEnd')"
            [defaultTime]="formGroup.get('hourEnd').value" [format]="24" [cancelBtnTmpl]="cancelBtn"
            [confirmBtnTmpl]="confirmBtn" [clockTheme]="customTimePickerTheme" [toggleIcon]="icon"
            [min]="dayStartHour" [max]="dayEndHour">
          </ngx-timepicker-field>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <frg-form-input
        id="room"
        type="ngSelect"
        [selectValue]="materialResources"
        label="Salle"
        [formGroup]="formGroup"
        [control]="formGroup.get('room')"
      ></frg-form-input>
    </div>

    <ng-template #cancelBtn>
      <div class="custom-btn">Annuler</div>
    </ng-template>
    <ng-template #confirmBtn>
      <div class="custom-btn">OK</div>
    </ng-template>
    <ng-template #icon>
      <img src="assets/icons/clock.svg" alt="clock" width="16" height="16">
    </ng-template>

    <frg-form-input
      id="address"
      type="text"
      label="Adresse / Complément"
      [formGroup]="formGroup"
      [control]="formGroup.get('address')"
    ></frg-form-input>

    <frg-form-input
      id="ordreDuJour"
      type="textarea"
      label="Ordre du jour"
      [required]="true"
      [formGroup]="formGroup"
      [control]="formGroup.get('ordreDuJour')"
    ></frg-form-input>

    <div class="wrapper">
      <div class="checkbox-form">
        <label class="checkbox">
          <input [formGroup]="formGroup" [formControl]="formGroup.get('isCoordinationMeeting')" type="checkbox">
          <span class="checkMark"></span>
        </label>
        <div class="label" [ngClass]="{ 'is-checked': formGroup && formGroup.get('isCoordinationMeeting') && formGroup.get('isCoordinationMeeting').value === true }">Réunion de concertation</div>
      </div>

      <div class="checkbox-form">
        <label class="checkbox">
          <input [formGroup]="formGroup" [formControl]="formGroup.get('isConsultationMeeting')" type="checkbox">
          <span class="checkMark"></span>
        </label>
        <div class="label" [ngClass]="{ 'is-checked': formGroup && formGroup.get('isConsultationMeeting') && formGroup.get('isConsultationMeeting').value === true }">Réunion d'information</div>
      </div>
    </div>

    <div class="wrapper-resources">
      <frg-form-input
        class="resources-list"
        id="secretary"
        type="ngSelect"
        [selectValue]="profilResources"
        isClearableSelect="false"
        label="Secrétaire / Rédigé par"
        [required]="true"
        [formGroup]="formGroup"
        [control]="formGroup.get('secretary')"
      ></frg-form-input>

      <frg-form-input
        class="resources-list"
        id="coordinator"
        type="ngSelect"
        [selectValue]="profilResources"
        isClearableSelect="false"
        label="Coordinateur de la réunion"
        [required]="true"
        [formGroup]="formGroup"
        [control]="formGroup.get('coordinator')"
      ></frg-form-input>
    </div>

    <div class="wrapper-resources">
      <div class="table-container">
        <div class="table-label">Liste du personnel soignant impliqué *</div>
        <frg-table
          [keysBody]="caregiversTable"
          [keysColumn]="caregiversTableColumn"
          tableButton1="assets/icons/edit.svg"
          (onClick1)="caregiverIsPresent($event)"
          tableButton2="assets/icons/trash.svg"
          (onClick2)="removeCaregiver($event)"
        ></frg-table>
        <div class="buttons-container">
          <frg-button (activated)="addCaregiver()">Ajouter</frg-button>
        </div>
      </div>
      <div class="table-container">
        <div class="table-label">Liste des patients concernés</div>
        <frg-table
          [keysBody]="patientsTable"
          [keysColumn]="patientsTableColumn"
          tableButton1="assets/icons/trash.svg"
          (onClick1)="removePatient($event)"
          isRowsClickable="true"
          (onClickRow)="addRemovePatient($event)"
        ></frg-table>
        <div class="icons-container">
          <div class="icon-wrapper" [title]="searchPatientButton.title" (click)="searchPatient()">
            <frg-inline-svg
              [fill]="searchPatientButton.icon.fill"
              [stroke]="searchPatientButton.icon.stroke"
              [src]="searchPatientButton.icon.src"
            ></frg-inline-svg>
          </div>
          <div class="icon-wrapper" [title]="patientToSeeButton.title" (click)="openPatientsToSee()">
            <frg-inline-svg
              [fill]="patientToSeeButton.icon.fill"
              [stroke]="patientToSeeButton.icon.stroke"
              [src]="patientToSeeButton.icon.src"
            ></frg-inline-svg>
          </div>
          <div class="icon-wrapper" [title]="listByAntecedentsButton.title" (click)="openListByAntecedents()">
            <frg-inline-svg
              [fill]="listByAntecedentsButton.icon.fill"
              [stroke]="listByAntecedentsButton.icon.stroke"
              [src]="listByAntecedentsButton.icon.src"
            ></frg-inline-svg>
          </div>
          <div class="icon-wrapper"
            [title]="addToPatientConsultationsButton.title"
            (click)="addMeetingToPatientsConsultations()"
            [ngClass]="{ 'disabled': selectedPatients.length <= 0 || !initialMeeting }">
            <frg-inline-svg
              [fill]="addToPatientConsultationsButton.icon.fill"
              [stroke]="addToPatientConsultationsButton.icon.stroke"
              [src]="addToPatientConsultationsButton.icon.src"
            ></frg-inline-svg>
          </div>
        </div>
      </div>
    </div>

    <div class="rich-text-container">
      <div class="froala-wrapper" [formGroup]="formGroup">
        <froala-editor class="froala-editor" [froalaEditor]="editorOptions" [(froalaModel)]="editorContent" id="froalaDrop" #froalaDrop (froalaInit)="initialize($event)"
            formControlName="report" placeholder="Ajouter du texte ici..." ></froala-editor>
      </div>
      <div class="buttons-container">
        <frg-button (activated)="printMeeting()">Imprimer</frg-button>
        <!-- <frg-button (activated)="sendMeetingByMail()">Envoyer par mail</frg-button> -->
      </div>
    </div>

    <div *ngIf="formGroup && formGroup.get('updatedAt')" class="last-update">{{ formGroup.get('updatedAt').value }}</div>

    <div class="buttons-container">
      <frg-button *ngIf="meetingId" (activated)="deleteMeeting()" [backgroundColor]="'var(--danger)'">Supprimer</frg-button>

      <frg-button (activated)="cancelChanges()" [backgroundColor]="'var(--darkest-primary)'" [disabled]="!hasFormChange">Annuler</frg-button>

      <frg-button (activated)="validMeeting()" [disabled]="!canValidMeeting()">Valider</frg-button>

      <frg-button (activated)="saveMeeting()">Enregistrer</frg-button>
    </div>
  </div>
</div>
